import { Users } from '@platform/client';
import { Avatar, Dropdown, DropdownItem } from '@platform/components';
import { useLocation } from 'wouter';
import { useMixpanelTrackLink } from '../analytics/mixpanel';
import dataTestids from '../constants/test-ids';
import useAccountMenuItems, { AccountMenuItem } from './useAccountMenuItems';

const NavUserMenuItem = (props: AccountMenuItem & { isActive: boolean }) => {
  const setMpRef = useMixpanelTrackLink<HTMLAnchorElement>(props.eventName);
  const href = props.isAbsolute ? props.href : `/platform${props.href}`;

  return (
    <DropdownItem href={href} isActive={props.isActive} ref={setMpRef}>
      {props.title}
    </DropdownItem>
  );
};

const NavUserMenu = () => {
  const { data: user, isSuccess } = Users.useGetCurrentUser();
  const { items } = useAccountMenuItems();
  const [currentRoute] = useLocation();

  return (
    <Dropdown
      type='button'
      ariaLabel='Account menu'
      buttonProps={{
        dataTestId: dataTestids.LAYOUT.NAV_USER_MENU,
        variant: 'tertiary-gray',
        size: 'lg',
        children: (
          <span className='flex items-center gap-3'>
            <Avatar type='avatar' avatarUrl={user?.avatar ?? undefined} size='md' renderAsDiv />
            <span className='text-gray-700 text-lg font-medium truncate max-w-[200px]'>
              {isSuccess ? `${user?.firstName} ${user?.lastName}` : ''}
            </span>
          </span>
        ),
      }}
    >
      {items.map((item) => (
        <NavUserMenuItem key={item.title} {...item} isActive={currentRoute === item.href} />
      ))}
    </Dropdown>
  );
};

export default NavUserMenu;
